import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useMemo } from 'react';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { useGetAllPublishedCollectionsQuery } from '../../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/SelfServePublicRpc.hooks';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { COLUMN_WIDTH } from '../../search-results/components/ResultsGridWithSummary';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { CollectionCard } from './CollectionCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SuggestedCollections({
  collectionIds
}) {
  const collectionResult = useCollectionQuery();
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackCollectionCardClicked = (collection, index) => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'collection card clicked',
      category: collection.slug,
      collectionId: collection.id,
      itemIndex: index,
      subscreen: Subscreens.SUGGESTED_COLLECTIONS
    }));
  };
  const trackCtaClicked = () => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'collection cta clicked',
      subscreen: Subscreens.SUGGESTED_COLLECTIONS
    }));
  };
  const {
    data
  } = useGetAllPublishedCollectionsQuery();
  const publishedCollections = useMemo(() => {
    var _data$collections;
    const allCollections = (data === null || data === void 0 || (_data$collections = data.collections) === null || _data$collections === void 0 ? void 0 : _data$collections.filter(collection => collection.displayed !== false)) || [];
    return allCollections.filter(c => {
      var _collectionResult$dat;
      if (collectionResult.isUmbrellaCollection) {
        return true;
      }
      return c.slug !== ((_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.slug);
    });
  }, [data === null || data === void 0 ? void 0 : data.collections, collectionResult.data, collectionResult.isUmbrellaCollection]);
  const collections = collectionIds && collectionIds.length > 0 ? publishedCollections.filter(c => collectionIds.includes(c.id)).sort((a, b) => collectionIds.indexOf(a.id) - collectionIds.indexOf(b.id)) : publishedCollections.sort(() => Math.random() - 0.5).slice(0, 2);
  if (collections.length === 0) return undefined;
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "1000",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexWrap: "wrap",
      gap: "400",
      justifyContent: "space-between",
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featuredCollection.ctaTitle"
        })
      }), /*#__PURE__*/_jsx(UIRouterLink, {
        to: Paths.FEATURED,
        onClick: trackCtaClicked,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featuredCollection.ctaLink"
        })
      })]
    }), /*#__PURE__*/_jsx(CardGrid, {
      columnSize: COLUMN_WIDTH,
      gap: "400",
      children: collections.map((collection, index) => /*#__PURE__*/_jsx(CollectionCard, {
        description: collection.description,
        name: collection.name,
        onClick: () => {
          trackCollectionCardClicked(collection, index);
          scrollToTop();
        },
        slug: collection.slug,
        previewItems: collection.previewItems,
        totalItemCount: collection.itemCount
      }, collection.slug))
    })]
  });
}